"use client";

import { c as _c } from "react/compiler-runtime";
import { Layout, useLayoutConfig } from "@xefi/x-react/layout";
import { Item, NavbarProps } from "@xefi/x-react/navbar";
import { SidebarProps } from "@xefi/x-react/sidebar";
import { usePathname, useRouter } from "next/navigation";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { SidebarBackground } from "./SidebarBackground";
import { FluxHeader } from "./FluxHeader";
import { ApplicationLogo } from "./DailyAppsLogo";
import { createNavigationItems } from "./createNavigationItems";
import { NAVBAR_MENU_ITEM_CLASSES, SIDEBAR_ITEM_CLASSES } from "./navigationClasses";
import { UserModel } from "../../domain/models/User";
import { usePermissions } from "@/hooks/usePermissions";
import { canAccessPayments } from "@/hooks/usePaymentsAccess";
type Props = {
  currentUser: UserModel | null;
  children: React.ReactNode;
};
type LayoutComponentProps = NavbarProps & SidebarProps;
export const FluxLayoutContent = t0 => {
  const $ = _c(36);
  const {
    currentUser,
    children
  } = t0;
  const router = useRouter();
  const pathname = usePathname();
  const {
    t
  } = useTranslation();
  const {
    hasPermission
  } = usePermissions();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  let t1;
  if ($[0] !== hasPermission) {
    t1 = hasPermission("manage user accesses");
    $[0] = hasPermission;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const canManageUserAccess = t1;
  const t2 = currentUser?.tabs;
  let t3;
  if ($[2] !== canManageUserAccess || $[3] !== currentUser || $[4] !== pathname || $[5] !== t || $[6] !== t2) {
    t3 = createNavigationItems({
      t,
      pathname,
      tabs: t2,
      canManageUserAccess,
      canAccessPayments: canAccessPayments(currentUser)
    });
    $[2] = canManageUserAccess;
    $[3] = currentUser;
    $[4] = pathname;
    $[5] = t;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const navigationItems = t3;
  let t4;
  if ($[8] !== router) {
    t4 = item => {
      if (item.href) {
        router.push(item.href);
      }
    };
    $[8] = router;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleItemClick = t4;
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = isOpen => {
      setIsSidebarCollapsed(!isOpen);
    };
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const handleMenuToggle = t5;
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <><p className="text-lg font-bold">Flux Financier</p></>;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== currentUser) {
    t7 = <FluxHeader currentUser={currentUser} />;
    $[12] = currentUser;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      base: "shadow-md bbg-white dark:bg-content1 dark:shadow-none border-b border-border",
      content: "pl-3 pr-6",
      item: NAVBAR_MENU_ITEM_CLASSES
    };
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== handleItemClick || $[16] !== navigationItems || $[17] !== t7) {
    t9 = {
      appName: t6,
      onItemClick: handleItemClick,
      profile: t7,
      classNames: t8,
      onMenuOpenChange: handleMenuToggle,
      menuItems: navigationItems
    };
    $[15] = handleItemClick;
    $[16] = navigationItems;
    $[17] = t7;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="flex w-55 justify-center"><ApplicationLogo /></div>;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const t11 = isSidebarCollapsed ? undefined : SIDEBAR_ITEM_CLASSES;
  let t12;
  if ($[20] !== t11) {
    t12 = {
      action: "rounded-none",
      item: t11
    };
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <SidebarBackground />;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = collapsed => {
      if (typeof collapsed === "boolean") {
        setIsSidebarCollapsed(collapsed);
      }
    };
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== handleItemClick || $[25] !== isSidebarCollapsed || $[26] !== navigationItems || $[27] !== t12) {
    t15 = {
      appLogo: t10,
      onItemClick: handleItemClick,
      classNames: t12,
      items: navigationItems,
      className: "bg-[#1E1E1E] text-gray-300",
      bgImage: t13,
      isCollapsed: isSidebarCollapsed,
      onToggle: t14
    };
    $[24] = handleItemClick;
    $[25] = isSidebarCollapsed;
    $[26] = navigationItems;
    $[27] = t12;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t15 || $[30] !== t9) {
    t16 = {
      navbar: t9,
      sidebar: t15
    };
    $[29] = t15;
    $[30] = t9;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  const layoutConfig = useLayoutConfig(t16);
  let t17;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      content: "p-6 max-w-none w-full"
    };
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== children || $[34] !== layoutConfig) {
    t18 = <><Layout {...layoutConfig} classNames={t17}>{children}</Layout></>;
    $[33] = children;
    $[34] = layoutConfig;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  return t18;
};